// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2284) return "static/chunks/2284-e17d20ef144795ef.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"343":"6edf0643","3524":"2170a4aa"}[chunkId] || chunkId) + "." + {"343":"d8a7c6b6bdcdfe66","2232":"165c84b566b760e7","3179":"cee18bb7df3a4643","3524":"02d9a64759bff447","5560":"7a0697839184d8d9","8436":"cab94b59cca0a8ff"}[chunkId] + ".js";
};